import {
  IconButton,
  Menu,
  MenuItem,
  VeBox,
  VeTypography,
} from "@packages/ui/mui";
import { useData } from "@providers/context";
import {
  BUSINESS_INFO,
  LINK_GREY,
  PROFILE_GREY_NEW,
  TEAMS,
} from "@public/index";
import Image from "next/image";
import { useRouter } from "next/navigation";
import React, { useState } from "react";
import { openOrFocusTab } from "@libs/helper";
import SettingsIcon from "@components/SvgComponents/SettingsIcon";

const SettingsDropdown = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const router = useRouter();
  const { userData } = useData();
  const orgId = userData?.user?.organisationId || "";

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // Define menu items - you can customize these based on your needs
  const menuItems = [
    {
      label: "General Settings",
      subtext: "Manage  personal preferences",
      onClick: () => {
        // Add navigation logic
        router.push("/settings/general");
        handleClose();
      },
      image: PROFILE_GREY_NEW,
    },
  ];

  const menuItems2 = [
    {
      label: "User Management",
      subtext: "Manage users, roles and user access ",
      onClick: () => {
        openOrFocusTab(`/admin/${orgId}/users`, "vericap-user-management");
        handleClose();
      },
      image: TEAMS,
    },
    {
      label: "Organisation Settings",
      subtext: "Manage organisation details",
      onClick: () => {
        openOrFocusTab(`/admin/${orgId}/overview`, "vericap-org-settings");
        handleClose();
      },
      image: BUSINESS_INFO,
    },
  ];

  return (
    <div>
      <IconButton
        onClick={handleClick}
        sx={{
          backgroundColor: anchorEl ? "#EFE9FB" : "transparent",
          borderRadius: anchorEl ? "50%" : "none",
          border: anchorEl ? "1px solid #703DDE" : "1px solid transparent",
          "&:hover": { backgroundColor: "#E8E8E8" },
          padding: "4px",
        }}
      >
        <SettingsIcon active={Boolean(anchorEl)} />
      </IconButton>

      <Menu
        id="app-dropdown-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        disableScrollLock
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        MenuListProps={{
          disablePadding: true,
        }}
        slotProps={{
          paper: {
            sx: {
              border: "1px solid #E8E8E8",
              borderRadius: "8px",
              paddingTop: "16px",
              paddingBottom: "16px",
              minWidth: "300px",
              boxShadow:
                "0px 2px 16px 0px rgba(0, 0, 0, 0.08), 0px 2px 8px -2px rgba(0, 0, 0, 0.12)",
              mt: "8px",
            },
          },
        }}
      >
        <VeBox display={"flex"} flexDirection={"column"} gap="8px">
          <VeBox
            display={"flex"}
            flexDirection="column"
            mb="8px"
            // sx={{ borderBottom: "1px solid #E8E8E8" }}
          >
            <VeTypography
              variant="label3StrongerSecondary"
              sx={{ marginLeft: "16px", marginRight: "16px" }}
            >
              Personal Vericap settings
            </VeTypography>
            {menuItems.map((item, index) => (
              <MenuItem
                key={index}
                onClick={item.onClick}
                sx={{
                  borderRadius: "4px",
                  // padding: "8px 16px",
                  paddingTop: "8px",
                  paddingRight: "0px",
                  paddingLeft: "0px",
                  paddingBottom: "8px",
                  "&:hover": {
                    backgroundColor: "#F3F3F3",
                  },
                }}
              >
                <VeBox
                  display="flex"
                  flexDirection="row"
                  gap="8px"
                  alignItems="center"
                >
                  <Image
                    src={item.image}
                    alt={item.label}
                    style={{ marginLeft: "16px" }}
                  />
                  <VeBox
                    display="flex"
                    flexDirection="column"
                    gap="4px"
                    style={{ marginRight: "16px" }}
                  >
                    <VeTypography variant="label2Main">
                      {item.label}
                    </VeTypography>
                    <VeTypography variant="label3Secondary">
                      {item.subtext}
                    </VeTypography>
                  </VeBox>
                </VeBox>
              </MenuItem>
            ))}
          </VeBox>
          <VeBox display={"flex"} flexDirection="column">
            <VeTypography
              variant="label3StrongerSecondary"
              sx={{ marginLeft: "16px", marginRight: "16px" ,paddingBottom:"2px"}}
            >
              Vericap admin settings
            </VeTypography>
            {menuItems2.map((item, index) => (
              <MenuItem
                key={index}
                onClick={item.onClick}
                sx={{
                  borderRadius: "4px",
                  paddingTop: "8px",
                  paddingRight: "0px",
                  paddingLeft: "0px",
                  paddingBottom: "8px",
                  marginBottom: "8px",
                  "&:hover": {
                    backgroundColor: "#F3F3F3",
                  },
                }}
              >
                <VeBox
                  display={"flex"}
                  flexDirection={"row"}
                  justifyContent={"space-between"}
                  alignItems={"center"}
                  width={"100%"}
                  gap={'12px'}
                >
                  <VeBox
                    display="flex"
                    flexDirection="row"
                    gap="8px"
                    alignItems="center"
                  >
                    <Image
                      src={item.image}
                      alt={item.label}
                      style={{ marginLeft: "16px" }}
                    />
                    <VeBox display="flex" flexDirection="column" gap="4px">
                      <VeTypography variant="label2Main">
                        {item.label}
                      </VeTypography>
                      <VeTypography variant="label3Secondary">
                        {item.subtext}
                      </VeTypography>
                    </VeBox>
                  </VeBox>
                  <Image
                    src={LINK_GREY}
                    alt="redirect"
                    height={20}
                    width={20}
                    style={{ marginRight: "16px" }}
                  />
                </VeBox>
              </MenuItem>
            ))}
          </VeBox>
        </VeBox>
      </Menu>
    </div>
  );
};

export default SettingsDropdown;
